"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plus = void 0;
const react_1 = __importDefault(require("react"));
const Plus = ({ size, color, outline }) => {
    if (outline) {
        return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 52 52", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("circle", { cx: "25", cy: "25", r: "23.571", stroke: color || '#25CFBB', strokeWidth: "2.857" }),
            react_1.default.createElement("rect", { x: "24.28", y: "13.438", width: ".924", height: "23.125", rx: ".462", fill: color || '#2EB3B4', stroke: color || '#25CFBB', strokeWidth: ".625" }),
            react_1.default.createElement("rect", { x: "36.563", y: "24.28", width: ".924", height: "23.125", rx: ".462", transform: "rotate(90 36.563 24.28)", fill: color || '#2EB3B4', stroke: color || '#25CFBB', strokeWidth: ".625" })));
    }
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 50 50", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M24.9283 3.02246V24.9293M24.9283 46.8362V24.9293M24.9283 24.9293H46.8352M24.9283 24.9293H3.02148", stroke: color || '#25CFBB', strokeWidth: "5.65338", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.Plus = Plus;
